import request from '@/utils/request';

// 获取列表
export function GetList(params) {
    return request({
        url: '/api/order/my/page',
        method: 'GET',
        params: params
    });
}

// 取消订单
export function Del(params) {
  return request({
    url: '/api/order/my/delete',
    method: 'GET',
    params: params
  });
}

// 支付宝支付订单
export function AlipayThenPay(data) {
  return request({
    url: '/api/order/plaer/alipayThenPay',
    method: 'POST',
    data
  });
}

// 微信支付订单
export function WxThenPay(data) {
    return request({
        url: '/api/order/plaer/wexinThenPay',
        method: 'POST',
        data
    });
}

// 确认相关文件
export function FileConfirmation(data) {
    return request({
        url: '/api/order/my/fileConfirmation',
        method: 'POST',
        data
    });
}

// 再来一单
export function GetOrderSku(params) {
    return request({
        url: '/api/good/getOrderSku',
        method: 'GET',
        params: params
    });
}

// 健康报告
export function GetLookHealthReport(params) {
    return request({
        url: '/api/order/my/lookHealthReport',
        method: 'GET',
        params: params
    });
}

// 出库单
export function LookOutbound(params) {
    return request({
        url: '/api/order/my/lookOutbound',
        method: 'GET',
        params: params
    });
}

// 获取登录用户信息
export function GetUserInfo() {
    return request({
        url: '/api/user/info/getInfo',
        method: 'GET',
    });
}

// 项目进展
export function OpenProgress(params) {
    return request({
        url: '/api/order/my/getOrderProjectProgressList',
        method: 'GET',
        params: params
    });
}


// 获取商品详情
export function GetDetail(params) {
    return request({
        url: '/api/order/my/newDetail',
        method: 'GET',
        params: params
    });
}

// 获取售后列表
export function GetSalesAfterList(params) {
    return request({
        url: '/api/order/salesAfter/getList',
        method: 'GET',
        params: params
    });
}

// 提交售后信息
export function SalesAfterSave(data) {
    return request({
        url: '/api/order/salesAfter/commit',
        method: 'POST',
        data
    });
}